var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('outro-template',{attrs:{"status":"success","hide-content":true,"show-exit-button":true},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Déclencher le paiement des heures excédentaires ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }